import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RequireSuperadmin } from './auth/RequireSuperadmin'
import { RedirectAdminWiki } from './pages/wiki/RedirectAdminWiki'

// Wiki interna: chunk aparte (KaTeX, mermaid, react-markdown) que solo baja
// quien la abre. El contenido no está en el bundle: lo sirve el backend.
const WikiPage = lazy(() => import('./pages/wiki/WikiPage'))

export const wikiRoutes: RouteObject[] = [
  {
    // Wiki interna (wiki/ del repo, servida por /admin/wiki/* del backend):
    // sitio de documentación de pantalla completa, sin el chrome del admin.
    // Solo administradores; sin sesión, al login con retorno.
    path: '/wiki/*',
    element: (
      <RequireSuperadmin>
        <Suspense fallback={<div className="min-h-screen bg-brand-amethystPaper" />}>
          <WikiPage />
        </Suspense>
      </RequireSuperadmin>
    ),
  },
  {
    // La wiki vivía dentro del admin: los links ya compartidos rebotan a /wiki.
    path: '/admin/wiki/*',
    element: <RedirectAdminWiki />,
  },
]
